export const onNodesDeleteCallback =
  ({ setIsPanelOpened, api }) =>
  async (nodes) => {
    setIsPanelOpened(false);
    for (var k = 0; k < nodes.length; k++) {
      const node = nodes[k];
      if (node.data?.nodeId) {
        await api.flowNode.delete(node.data?.nodeId);
      }

      if (node.type === "message" && node.data?.messageSkeletonId) {
        await api.messageSkeleton.delete(node.data?.messageSkeletonId);
      } else if (node.type === "template" && node.data?.messageSkeletonId) {
        await api.messageSkeleton.delete(node.data?.messageSkeletonId);
      } else if (node.type === "template" && node.data?.whatsappTemplateId) {
        await api.whatsappTemplate.delete(node.data?.whatsappTemplateId);
      } else if (node.type === "wait" && node.data?.waitingNodeId) {
        await api.waitingNode.delete(node.data?.waitingNodeId);
      } else if (node.type === "ai" && node.data?.aiConfigurationId) {
        await api.aiConfiguration.delete(node.data?.aiConfigurationId);
      }

      for (let index = 0; index < (node.data?.buttons ?? []).length; index++) {
        const b = node.data.buttons[index];
        if (b?.gadgetId) {
          await api.flowNode.delete(b?.gadgetId);
        }
        if (b?.replyButtonGadgetId) {
          await api.replyButton.delete(b?.replyButtonGadgetId);
        } else if (b?.replyListGadgetId) {
          await api.replyList.delete(b?.replyListGadgetId);
        }
      }
    }
  };
